<template>
  <div>
    <Navbar />
    <div class>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">404 Not Found</h2>
            <h2 class="title">Oops! It seems that this page does not exist.</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
export default {
  components:{
    Navbar
  }
};
</script>
